import { Component, OnInit } from '@angular/core';
import Print from "@arcgis/core/widgets/Print";
import { MapService } from 'src/app/view/services/map.service';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  constructor(
   public  mapService: MapService
  ) { }

  ngOnInit(): void {
    this.setUpPrint()
  }

  setUpPrint(){
      new Print({
      view: this.mapService.getViewMap(),
      container: "printContainer",
      // this is gisrealidad5 print service.
      printServiceUrl:
         "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"  //https://gisrealidad5.com/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task
    });
    
  }
}
